import { createFileRoute, Outlet } from "@tanstack/react-router";
import { StepFlowLayout } from "~/components/layouts/StepFlowLayout";
import { useFlowStart } from "~/hooks/use-flow-start";

export const Route = createFileRoute("/(authenticated)/uitbetaling-instellen")({
  component: UitbetalingInstellenLayout,
});

function UitbetalingInstellenLayout() {
  useFlowStart("uitbetaling");

  return (
    <StepFlowLayout currentStep={1} totalSteps={1}>
      <Outlet />
    </StepFlowLayout>
  );
}
